import ColouredRoundWrapper from "../UI/wrappers/ColouredRoundWrapper";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as XIcon } from "../../assets/icons/x_grey.svg";
import searchStyles from "../../styles/search.module.css";
import labels from "../../utils/labels";
const SearchBar = ({
  input,
  appliedFilters,
  onInputChange,
  onClearAll,
  placeholder,
  allowFurtherSearch,
  onFocus,
  onInputKeyDown,
  inputRef,
}: {
  input: string;
  appliedFilters?: React.ReactNode[];
  onInputChange: (value: string) => void;
  onClearAll: () => void;
  placeholder: string;
  allowFurtherSearch: boolean;
  onFocus?: () => void;
  onInputKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}) => {
  const hasAppliedFilters = appliedFilters && appliedFilters.length > 0;
  // When allowFurtherSearch is false and filters are applied, hide the text input
  // so the bar only shows chips (used by constraint search to lock selection).
  const hideInput = !allowFurtherSearch && hasAppliedFilters;
  const placeholderText = hideInput ? "" : placeholder;

  return (
    <div className={searchStyles.searchBarContainer}>
      <ColouredRoundWrapper
        bgColor=""
        padding
        width={"100%"}
        borderColor="var(--col-border-primary)"
        classes="!gap-[var(--spacing-sm)] relative bg-white hover:bg-[var(--col-surface-tertiary)] transition-colors"
      >
        {!hideInput && <SearchIcon />}

        {hasAppliedFilters && (
          <div className="flex flex-row">{appliedFilters}</div>
        )}

        {!hideInput && (
          <input
            type="text"
            value={input}
            ref={inputRef}
            onChange={(e) => onInputChange(e.target.value)}
            onFocus={onFocus}
            onKeyDown={onInputKeyDown}
            placeholder={placeholderText}
            className={`bg-transparent ${searchStyles.searchInputField} w-[100%] focus:outline-none`}
            style={{ height: "100%" }}
          />
        )}

        {hasAppliedFilters && (
          <button
            type="button"
            aria-label={labels.clearSearch}
            className="min-w-[14px] cursor-pointer absolute right-[16px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--col-border-focus)] focus-visible:outline-offset-1 rounded-full"
            onClick={onClearAll}
          >
            <XIcon width={14} height={14} />
          </button>
        )}
      </ColouredRoundWrapper>
    </div>
  );
};

export default SearchBar;
